<template>
    <div class="address-forms form-group mb15">
        <p class="alert" :class="'alert-'+ message.type" v-if="message.text">
            {{ message.text }}
        </p>
        <label>
            {{ label }} (建物名・お部屋番号までご記入ください)
            <span v-if="required" class="text-danger">※必須</span>
        </label>
        <div class="row">
            <div class="col-md-12">
                <label class="address-label">郵便番号(ハイフンなし)<span class="text-danger">※必須</span></label>
                <div class="flex align-items-center">
                    <span class="mr10">〒</span>
                    <input
                        :name="name+'.post_code'"
                        placeholder="郵便番号"
                        type="number"
                        style="width: 130px; margin-right: 20px"
                        class=" form-control p-postal-code no-spin"
                        :class="{'invalid': addressForm.form.errors.has('post_code')}"
                        size="8"
                        v-model="addressForm.postCode"
                        @change="update"
                        maxlength="8">
                    <button
                        type="button"
                        @click="searchAddress"
                        class="btn btn-accent">
                        郵便番号で住所検索
                    </button>
                </div>
                <HasError :field="name+'_post_code'" :form="addressForm.form" />
                <HasError :field="name+'.post_code'" :form="addressForm.form" />
            </div>
            <div class="col-md-12">
                <label class="address-label">都道府県<span class="text-danger">※必須</span></label>
                <input
                    :name="name+'.pref'"
                    placeholder="例：〇〇県"
                    required="required"
                    type="text"
                    v-model="addressForm.pref"
                    class="form-control"
                    :class="{'invalid': addressForm.form.errors.has('pref')}"
                    @change="update"
                />
                <HasError :field="name+'_pref'" :form="addressForm.form" />
                <HasError :field="name+'.pref'" :form="addressForm.form" />
            </div>
            <div class="col-md-12">
                <label class="address-label">市区町村<span class="text-danger">※必須</span></label>
                <input
                    :name="name+'.city'"
                    placeholder="例：〇〇市"
                    required="required"
                    type="text"
                    v-model="addressForm.city"
                    class="form-control"
                    :class="{'invalid': addressForm.form.errors.has('city')}"
                    @change="update"
                />
                <HasError :field="name+'_city'" :form="addressForm.form" />
                <HasError :field="name+'.city'" :form="addressForm.form" />
            </div>
            <div class="col-md-12">
                <label class="address-label">番地<span class="text-danger">※必須</span></label>
                <input
                    :name="name+'.town'"
                    placeholder="例：南青山1-1-1"
                    required="required"
                    type="text"
                    v-model="addressForm.town"
                    class="form-control"
                    :class="{'invalid': addressForm.form.errors.has('town')}"
                    @change="update"
                />
                <HasError :field="name+'_town'" :form="addressForm.form" />
                <HasError :field="name+'.town'" :form="addressForm.form" />
            </div>
            <div class="col-md-12">
                <label class="address-label">建物名・部屋番号</label>
                <input
                    :name="name+'.building'"
                    required="required"
                    type="text"
                    v-model="addressForm.building"
                    class="form-control"
                    :class="{'invalid': addressForm.form.errors.has('building')}"
                    @change="update"
                />
                <HasError :field="name+'_building'" :form="addressForm.form" />
                <HasError :field="name+'.building'" :form="addressForm.form" />
            </div>
        </div>

        <template v-if="postType !== 'form'">
            <div class="d-flex text-right pt15">
                <slot name="back"></slot>
                <input
                    type="button"
                    @click="onSubmit()"
                    class="btn btn-primary min-width"
                    :value="submitText"/>
            </div>
        </template>
    </div>
</template>

<script>
import UserDeliveryAddress from '../../models/UserDeliveryAddress'
import {action} from '../../store/types'
import {mapActions} from 'vuex'
import {HasError} from 'vform'
import OrderDeliveryAddress from "../../models/OrderDeliveryAddress";

export default {
    name: 'address-forms2',

    data() {
        return {
            message: {
                type: 'info',
                text: '',
            },
            addressForm: new OrderDeliveryAddress(),
        }
    },

    props: {
        label: {
            type: String,
            default: '',
        },
        postType: {
            type: String,
            default: 'create',
            validator: (v) => {
                return ["form", "create", "update"].indexOf(v) !== -1;
            },
        },
        addressModel: {
            default: () => new OrderDeliveryAddress(),
        },

        submitText: {
            type: String,
            default: '登録',
        },
        required: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '',
        }
    },

    watch: {
        addressModel(val) {
            console.log('address2 watch')
            console.log(val)
            this.addressForm = new OrderDeliveryAddress({...val})
        }
    },

    created() {
        this.addressForm = new OrderDeliveryAddress({...this.addressModel})
        axios.defaults.baseURL = process.env.MIX_APP_URL
    },

    methods: {
        ...mapActions([
            action.LOADING_UPDATE,
        ]),

        update() {
            this.$emit('change', this.addressForm)
        },

        async searchAddress() {
            this.message.text = ''
            this.addressForm.form.clear()
            axios.get('api/zipcode/' + this.addressForm.postCode)
                .then((res) => {
                    if (res.data.err) return this.onMessage('住所が取得できませんでした', 'error')
                    this.addressForm.pref = res.data[0].pref
                    this.addressForm.city = res.data[0].city
                    this.addressForm.town = res.data[0].town
                    this.update()
                })
                .catch(e => {
                    this.onMessage('住所が取得できませんでした', 'error')
                })
        },

        onSubmit() {
            this.message.text = ''
            this.createDeliveryAddress()
        },

        async createDeliveryAddress() {
            try {
                this[action.LOADING_UPDATE](true)
                const { data } = await this.addressForm.post(`/api/mypage/user/add-address`)
                this.onMessage('登録しました')
                this.addressForm = new UserDeliveryAddress()
                this.$emit('submit', new UserDeliveryAddress({...data}))
            } catch (e) {
                console.error(e)
            } finally {
                this[action.LOADING_UPDATE](false)
            }
        },

        onMessage(text, isDanger = false) {
            this.message.text = text
            this.message.type = isDanger ? 'danger' : 'info'
        }
    },

    components: {
        HasError
    }


}

</script>

<style lang="scss" scoped>
.address-forms {

    label {
        font-weight: bold;
    }

    .help-block {
        color: red;
    }

    .form-control.invalid {
        border-color: red;
    }

    .address-label {
        font-size: 13px;
        padding-top: 10px;
    }

    .btn-accent.white {
        color: #000;
        background-color: #fff;
        &:hover {
            color: #fff;
            background-color: #000;
        }
    }

    .checkout-radio {
        height: 45px;
        margin-top: 0;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/checkout/AddressForms2.vue